<template>
  <el-drawer
    title=""
    :visible="showDrawer"
    direction="rtl"
    size="383px"
    :append-to-body="true"
    :before-close="handleClose"
    :wrapperClosable="false">
    <div class="content">
      <div class="detail-header flex-container flex-row flex-verti-top flex-horiz-apart">
        <h3 class="detail-name line-no-wrap" :title="componentName">
          {{componentName}}
        </h3>
        <div class="buttons">
          <el-button type="primary" v-if="platform==='g' && showLoadButton" @click="loadComponent">载入</el-button>
          <el-button type="primary" v-if="platform!=='web' && showPlaceButton" @click="placeComponent">布置</el-button>
        </div>
      </div>
      <detail-views
        ref="detailViews"
        class="detail-views"
        :platform="platform"
        :detail="detail"
        :thumbnails="thumbnails"
        :current-type="currentType"
        :geometry-data="geometryData"
        :view-token="viewToken"
        :three-api="threeApi"
        :input-parameters="inputParameters"
        :placeholders="placeholders"
        @change-view="changeView" />
      <detail-properties
        v-if="familyTypes.length"
        class="detail-properties"
        :properties="properties"
        :family-types="familyTypes"
        :current-type="currentType"
        @change-type="changeFamilyType" />
    </div>
  </el-drawer>
</template>

<script>
import DetailViews from '@/components/business/compDetail/DetailViews'
import DetailProperties from '@/components/business/compDetail/DetailProperties'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    DetailViews,
    DetailProperties
  },
  props: {
    // 是否显示载入按钮
    showLoadButton: {
      type: Boolean,
      default: true
    },
    // 是否显示布置按钮
    showPlaceButton: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      platform: null,
      showDrawer: false,
      component: {},

    }
  },
  computed: {
    ...mapGetters({
      detail: 'componentDetail/DETAIL',
      thumbnails: 'componentDetail/THUMBNAILS',
      geometryData: 'componentDetail/GEOMETRY_DATA',
      viewToken: 'componentDetail/VIEW_TOKEN',
      inputParameters: 'componentDetail/INPUT_PARAMETERS',
      placeholders: 'componentDetail/PLACEHOLDERS',
      properties: 'componentDetail/PROPERTIES',
      familyTypes: 'componentDetail/FAMILYTYPES'
    }),
    componentName() {
      const comp = this.component
      return comp.componentFamilyTypeName ? `${comp.name}_${comp.componentFamilyTypeName}` : comp.name
    },
    currentType: {
      get() {
        return this.$store.getters[`componentDetail/CURRENTTYPE`]
      },
      set(val) {
        this.setCurrentType(val)
      }
    },
    threeApi() {
      return '/digital_components/gcmp_server/display_data'
    },
  },
  methods: {
    ...mapMutations({
      setComponentId: 'componentDetail/SET_ID',
      setCurrentType: 'componentDetail/SET_CURRENT_TYPE',
      setDetail: 'componentDetail/SET_DETAIL',
      setViewToken: 'componentDetail/SET_VIEW_TOKEN'
    }),
    ...mapActions({
      loadDetail: 'componentDetail/LOAD_DETAIL',
      loadProperties: 'componentDetail/LOAD_PROPERTIES',
      loadPlaceholders: 'componentDetail/LOAD_PLACEHOLDERS',
      loadViewToken: 'componentDetail/LOAD_VIEW_TOKEN'
    }),
    async open(comp, platform) {
      this.platform = platform
      this.component = comp
      this.setComponentId(comp.id)
      this.setDetail({})
      this.setViewToken(null)
      this.showDrawer = true
      if (this.$refs.detailViews && this.$refs.detailViews.$refs.detailViewsTab) {
        this.$refs.detailViews.currentView = 'thumbnail'
        this.$refs.detailViews.$refs.detailViewsTab.reset()
      }
      const detailQuery = {
        softwareCode: comp.softwareCode,
        softwareVersion: comp.softwareVersion,
        familyTypeName: comp.componentFamilyTypeName
      }
      await this.loadDetail(detailQuery)
      await this.loadProperties()
    },
    handleClose() {
      this.setComponentId(null)
      this.showDrawer = false
    },
    loadComponent() {
      this.$emit('load-g-component', this.component)
    },
    placeComponent() {
      if (this.platform === 'g') {
        this.$emit('place-g-component', this.component)
      } else if (this.platform === 'cs') {
        this.$emit('place-cs-component', this.component)
      } else {
        this.$emit('place-r-component', this.component)
      }
    },
    async changeView(id) {
      if (this.platform === 'g' && this.detail.hasPlaceholder && id === 'placeholder') {
        if (this.detail.placeholders && this.detail.placeholders.length) {
          await this.loadPlaceholders()
        }
      } else if (this.platform !== 'g' && id === '3d' && !this.viewToken) {
        this.loadViewToken()
      }
    },
    async changeFamilyType(selected) {
      const familyType = this.familyTypes.find(type => type.id === selected.id)
      // 先请求properties  保证gjw-three获取到准确的inputParameters
      await this.loadProperties(familyType)
      this.currentType = familyType
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-drawer__header{
  margin-bottom: 6px;
  padding: 6px 12px;
}
.content{
  padding: 0 12px 24px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.detail-header{
  color: @theme-grey-1;
  flex-shrink: 0;
}
.detail-name{
  font-size: 1.2857rem;
  max-width: 60%;
}
.detail-views{
  border-bottom: 1px solid @theme-border-color;
  min-height: 212px;
}
.detail-properties{
  flex-grow: 1;
  min-height: 1px;
}
</style>
